import GameStatesEnum from "../GameStatesEnum"
import BaseState from '@state/BaseState'
import { Signals} from "@/Imports";
import Config from "../../config/Config";
import Facade from "../../Facade";

export default class StartCountingUpWinningsState extends BaseState {

  begin() {
    if(this.model.stateSkipped) {
      let requireCounting = false
      console.log('StartCountingUpWinningsState  ')
      Signals.startCountingUpWinnings.dispatch({winnings: this.model.totalWin, requireCounting: requireCounting, bigwin: Facade.model.bigWin})
      this.end ()
      return
    }
    let requireCounting = this.model.totalWin >= Config.MIN_COUNTUP_WIN * Facade.model._totalBetNumber
    Signals.startCountingUpWinnings.dispatch({winnings: this.model.totalWin, requireCounting: requireCounting, bigwin: Facade.model.bigWin})
  }

  end = () => {
    /*this.gameState = GameStatesEnum.SHOW_CYCLEWINNINGS
    if(this.model.isAuto || this.model.isFreespinsMode || this.model.isBonusStarted) {
      this.model.totalWin = 0
      this.gameState = GameStatesEnum.FINAL
    }

    this.stateMachine.setState(this.gameState)*/
	}

  skip() {
    // if(Facade.model.bigWin) {
    //   return
    // }
    this.model.stateSkipped = true
    Signals.skip.dispatch()
  }

  cleanUp() {
    Signals.countingUpComplete.remove(this.end, this)
    Signals.spinBtnPressed.remove(this.skip, this)
  }
}